import { Cart } from "@insite/client-framework/Services/CartService";
import { canPlaceOrder } from "@insite/client-framework/Store/Data/Carts/CartsSelector";

export const getCartMessage = (cartMessages: string[] | null, messagePrefix: string) => {
    const messages = cartMessages?.filter(m => m.startsWith(messagePrefix));
    const message = messages && messages.length > 0 ? messages[0].replace(messagePrefix, "") : "";
    return message;
};

export const getCartMessages = (cartMessages: string[] | null, messagePrefix: string) => {
    const messagesFound = cartMessages?.filter(m => m.startsWith(messagePrefix));
    const messages =
        messagesFound && messagesFound.length > 0 ? messagesFound.map((msg, i) => msg.replace(messagePrefix, "")) : "";
    return messages;
};

export const getCartLineProductMessages = (cartMessages: string[] | null, messagePrefix: string) => {
    const productMessages = cartMessages?.filter(m => m.startsWith(messagePrefix));
    let productMessageList = new Array<string>();
    if (productMessages && productMessages.length > 0) {
        productMessageList = productMessages?.map(productMessage => {
            return productMessage.replace(messagePrefix, "");
        });
    }
    return productMessageList;
};

export const xcCanPlaceOrder = (cart: Cart | undefined) => {
    return canPlaceOrder(cart) && !(cart?.fulfillmentMethod === "Ship" && cart?.carrier?.id === null);
};
